import React from 'react';
import { Row, Col, Button, ProgressBar, OverlayTrigger, Tooltip, Alert } from 'react-bootstrap';
import { Helmet } from "react-helmet";
import { MyContext } from '../InitialSetup/MyProvider';
import { Utilities, _Map, _isUndefined, _filter, _cloneDeep } from '../Utilities/Utilities';
import { setValue, AppSelectedSport, preTeamsList } from '../helper/Constants';
import { Sports } from "../JsonFiles";
import { getFixtureDetail, getFixtureDetailMultiGame, getFixtureContestList, getUserTeams, joinContest, joinContestNetworkfantasy, joinContestWithMultiTeam, joinContestWithMultiTeamNF } from "../WSHelper/WSCallings";
import InfiniteScroll from 'react-infinite-scroll-component';
import Skeleton from 'react-loading-skeleton';
import ls from 'local-storage';
import Images from '../components/images';
import WSManager from "../WSHelper/WSManager";
import * as WSC from "../WSHelper/WSConstants";
import * as AppLabels from "../helper/AppLabels";
import MetaData from "../helper/MetaData";
import CustomHeader from '../components/CustomHeader';
import CollectionSlider from "./CollectionSlider";
import Thankyou from '../Modals/Thankyou';
import ContestDetailModal from '../Modals/ContestDetail';
import ConfirmationPopup from '../Modals/ConfirmationPopup';
import ShareContestModal from '../Modals/ShareContestModal';
import CollectionInfoModal from "../Modals/CollectionInfo";
import { NoDataView } from '../Component/CustomComponent';
import { createBrowserHistory } from 'history';
import * as Constants from "../helper/Constants";
import { DownloadAppBuyCoinModal } from "../Modals";
import Filter from "../components/filter";
import MyAlert from '../Modals/MyAlert';
import MaterialIcon from 'material-icons-react';

const history = createBrowserHistory();
const location = history.location;
const queryString = require('query-string');
const parsed = queryString.parse(location.search);

var globalThis = null;

/**
  * @description Display shimmer effects while loading list
  * @return UI components
*/
const Shimmer = ({ index }) => {
    return (<div key={index} className="contest-list m">
        <div className="shimmer-container">
            <div className="shimmer-top-view">
                <div className="shimmer-line">
                    <Skeleton height={9} />
                    <Skeleton height={6} />
                    <Skeleton height={4} width={100} />
                </div>
                <div className="shimmer-image">
                    <Skeleton width={30} height={30} />
                </div>
            </div>
            <div className="shimmer-bottom-view">
                <div className="progress-bar-default">
                    <Skeleton height={6} />
                    <div className="d-flex justify-content-between">
                        <Skeleton height={4} width={60} />
                        <Skeleton height={4} width={60} />
                    </div>
                </div>
                <div className="shimmer-buttin">
                    <Skeleton height={30} />
                </div>
            </div>
        </div>
    </div>)
}

const sorting = ["Default", "Group", "Prize Pool", "Entry Fee"]

const groups = [{
    name: 'All',
    items: ["1", "4", "5", "9", "2", "8", "12", "10", "6", "16", "17"]
},
{
    name: 'Head2Head',
    items: ["9", "2"]
},
{
    name: 'WTA',
    items: ["18", "10"]
},
{
    name: 'Others',
    items: ["1", "4", "5", "8", "12", "6", "16", "17"]
}
]

export default class ContestListing extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lineup_master_id: '',
            lineup_master_idArray: [],
            FixturedContest: [],
            sortContestList: [],
            ShimmerList: [1, 2, 3, 4, 5],
            showContestDetail: false,
            WinnerCount: [],
            FixtureData: '',
            FixturedContestTotal: 0,
            SortContestTotal: '',
            FixturedPinContest: [],
            TeamList: [],
            TotalTeam: [],
            LobyyData: !_isUndefined(props.location.state) ? props.location.state.LobyyData : [],
            showConfirmationPopUp: false,
            userTeamListSend: [],
            showSharContestModal: false,
            activeTab: "",
            showLoadMore: true,
            showThankYouModal: false,
            hasMore: false,
            isListLoading: false,
            LoaderShow: false,
            showContestListFitler: false,
            isFilterApplied: false,
            showAlert: false,
            entry_fee_from: "",
            entry_fee_to: "",
            participants_from: "",
            participants_to: "",
            prizepool_from: "",
            prizepool_to: "",
            allowCollection: Utilities.getMasterData().a_collection,
            showCollectionInfo: false,
            selectedSort: typeof ls.get("selected_sort") == 'undefined' || ls.get("selected_sort") == null ? sorting[0] : ls.get("selected_sort"),
            currentlySelectedGroup: typeof ls.get("currently_selected_group") == 'undefined' || ls.get("currently_selected_group") == null ? 'All' : ls.get("currently_selected_group"),
            currentlySelectedGroupItems: typeof ls.get("currently_selected_group_items") == 'undefined' || ls.get("currently_selected_group_items") == null ? ["1", "4", "5", "9", "2", "8", "12", "10", "6", "16", "17"] : ls.get("currently_selected_group_items"),
            showGroups: false,
            allContestData: [],
            isNewCJoined: false,
            showDAM: false,
            showRF: this.props && this.props.location && this.props.location.state && this.props.location.state.isReverseF || false,
            showRFNPP: false,
            HeaderOption: {
                back: true,
                fixture: true,
                filter: true,
                title: '',
                hideShadow: false,
                goBackLobby: !_isUndefined(props.location.state) ? props.location.state.isFromPM : false
            },
            contestListFilterLoader: {
                "winning": {
                    "min": 0,
                    "max": 0
                },
                "entry_fee": {
                    "min": 0,
                    "max": 0
                },
                "entries": {
                    "min": 0,
                    "max": 0
                }
            },
            isContestListFilterSet:false,
        }
    }


    convertIntoWhole = (x) => {
        var no = Math.round(x)
        return no;
    }

    /**
     * @description lifecycle method of react,
     * method to load data of contest listing and user lineup list
     */
    componentDidMount() {
        Utilities.handleAppBackManage('contest-listing')
        Utilities.scrollToTop()
        globalThis = this;
        const matchParam = this.props.match.params;
        let RFContId = ls.get('RFContestID')
        if (parsed.sgmty) {
            let urlGT = atob(parsed.sgmty)
            WSManager.setPickedGameType(urlGT);
        }

        this.FixtureDetail(matchParam);

        if (WSManager.loggedIn()) {
            this.getUserLineUpListApi(matchParam);
            WSManager.googleTrackDaily(WSC.GA_PROFILE_ID, 'loggedInusers');
        }
        this.FixtureContestList(matchParam);
        this.headerRef.GetHeaderProps("lobbyheader", '', '', this.state.LobyyData ? this.state.LobyyData : this.props.location.state.LobyyData);
        WSManager.googleTrack(WSC.GA_PROFILE_ID, 'contestlist');

    }
    /**
     * @description lifecycle method of react,
     * method to load locale storage data and props data
     */
    UNSAFE_componentWillMount() {
        this.checkOldUrlPattern();
        let CinfirmPopUpIsAddFundsClicked = WSManager.getFromConfirmPopupAddFunds()
        let tempIsAddFundsClicked = WSManager.getFromFundsOnly()
        if (this.props.location.state && this.props.location.state.from == 'MyTeams') {
            this.setState({
                lineup_master_id: this.props.location.state.lineup_master_id,
                lineup_master_idArray: this.props.location.state.lineupObj || [],
                HeaderOption: {
                    back: true,
                    fixture: true,
                    filter: true,
                    title: '',
                    hideShadow: false,
                    goBackLobby: true
                }
            })
        }
        setTimeout(() => {
            if ((tempIsAddFundsClicked == 'true' && CinfirmPopUpIsAddFundsClicked == 'true') || CinfirmPopUpIsAddFundsClicked == true) {
                setTimeout(() => {
                    this.callAfterAddFundPopup()
                }, 200);
            }
        }, 500);
    }

    // componentWillUnmount() {
    //     ls.set('RFContestID', '')
    // }

    /**
     * @description this method is used to replace old url pattern to new eg. from "/7/contest-listing" to "/cricket/contest-listing"
     */
    checkOldUrlPattern = () => {

        let sportsId = this.props.match.params.sportsId;
        if (!(sportsId in Sports)) {
            if (sportsId in Sports.url) {
                let sportsId = this.props.match.params.sportsId;
                let collection_master_id = this.props.match.params.collection_master_id;
                let myKey = this.props.match.params.myKey;
                this.props.history.replace("/" + Sports.url[sportsId] + "/contest-listing/" + collection_master_id + "/" + myKey + "?sgmty=" + btoa(Constants.SELECTED_GAMET));
                return;
            }
        }
    }

    /**
     * 
     * @description method to refresh page contest when user pull down to refresh screen
     */
    async handleRefresh(resolve, reject) {
        if (!globalThis.state.isListLoading) {
            globalThis.setState({
                showLoadMore: true
            })
            globalThis.FixtureContestList(globalThis.props.match.params);
        }
    }
    /**
     * 
     * @description method to display confirmation popup model, when user join contest.
     */
    ConfirmatioPopUpShow = (data) => {
        this.setState({
            showConfirmationPopUp: true,
        });
    }
    /**
     * 
     * @description method to hide confirmation popup model
     */
    ConfirmatioPopUpHide = () => {
        this.setState({
            showConfirmationPopUp: false,
        });
    }
    /**
     * 
     * @description method to display collection info model.
     */
    CollectionInfoShow = (event) => {
        event.stopPropagation();
        this.setState({
            showCollectionInfo: true
        });
    }
    /**
     * 
     * @description method to hide collection info model.
     */
    CollectionInfoHide = () => {
        this.setState({
            showCollectionInfo: false,
        });
    }
    /**
     * 
     * @description method to display share contest popup model.
     */
    shareContestModalShow = (data) => {
        this.setState({
            showSharContestModal: true,
        });
    }
    /**
     * 
     * @description method to hide share contest popup model.
     */
    shareContestModalHide = () => {
        this.setState({
            showSharContestModal: false,
        });
    }
    /**
     * 
     * @description method invoke when user click on share contest icon
     * @param shareContestEvent - share contest event
     * @param FixturedContestItem - Contest model on which user click
     */
    shareContest(shareContestEvent, FixturedContestItem) {
        if (WSManager.loggedIn()) {
            shareContestEvent.stopPropagation();
            this.setState({ showSharContestModal: true, FixtureData: FixturedContestItem })
        } else {
            this.goToSignup()
        }
    }

    /**
     * @description Method to open signup screen for guest user share contest click event
     */
    goToSignup = () => {
        this.props.history.push("/signup")
    }

    /**
     * @description Method to check user is guest on loggedin in case user join
     * @param {*} event - click event
     * @param {*} FixturedContestItem - contest model on which user click
     */
    check(event, FixturedContestItem) {
        WSManager.loggedIn() ? globalThis.joinGame(event, FixturedContestItem) : globalThis.goToSignup()
    }

    /**
    * @description Method called when user loggedin  and click on join game 
    * @param {*} event - click event
    * @param {*} FixturedContestItem - contest model on which user click
    * @param {*} teamListData - user created team list of same collection
    */
    joinGame(event, FixturedContestItem, teamListData) {
        if (event) {
            event.stopPropagation();
        }
        WSManager.clearLineup();
        if (this.state.TeamList.length > 0 || (teamListData && teamListData != null && teamListData.length > 0)) {
            /*if (this.state.TeamList.length > 1 || (teamListData && teamListData != null && teamListData.length > 1)) {
                console.log("Teams Count is more than 1 for this contest")
            } else {*/
            this.setState({ showConfirmationPopUp: true, FixtureData: FixturedContestItem })
            //}
        }
        else {
            if (this.state.TotalTeam.length == parseInt(Utilities.getMasterData().a_teams)) {
                this.openAlert()
            }
            else {
                this.goToLineup(FixturedContestItem)
                // let urlData = this.state.LobyyData;
                // let dateformaturl = Utilities.getUtcToLocal(urlData.season_scheduled_date);
                // dateformaturl = new Date(dateformaturl);
                // let dateformaturlDate = ("0" + dateformaturl.getDate()).slice(-2)
                // let dateformaturlMonth = ("0" + (dateformaturl.getMonth() + 1)).slice(-2)
                // dateformaturl = dateformaturlDate + '-' + dateformaturlMonth + '-' + dateformaturl.getFullYear();
                // let lineupPath = ''
                // if (urlData.home) {
                //     lineupPath = '/lineup/' + urlData.home + "-vs-" + urlData.away + "-" + dateformaturl
                // }
                // else {
                //     lineupPath = '/lineup/' + Utilities.replaceAll(urlData.collection_name, ' ', '_')
                // }

                // this.props.history.push({ pathname: lineupPath.toLowerCase(), state: { FixturedContest: FixturedContestItem, LobyyData: this.state.LobyyData, resetIndex: 1, isCollectionEnable: (Constants.SELECTED_GAMET == Constants.GameType.MultiGame && this.state.LobyyData.match_list && this.state.LobyyData.match_list.length > 1),isReverseF: this.state.showRF } })
            }
        }
        WSManager.setFromConfirmPopupAddFunds(false);
    }

    goToLineup = (FixturedContestItem) => {
        let urlData = this.state.LobyyData;
        let dateformaturl = Utilities.getUtcToLocal(urlData.season_scheduled_date);
        dateformaturl = new Date(dateformaturl);
        let dateformaturlDate = ("0" + dateformaturl.getDate()).slice(-2)
        let dateformaturlMonth = ("0" + (dateformaturl.getMonth() + 1)).slice(-2)
        dateformaturl = dateformaturlDate + '-' + dateformaturlMonth + '-' + dateformaturl.getFullYear();
        let lineupPath = ''
        if (urlData.home) {
            lineupPath = '/lineup/' + urlData.home + "-vs-" + urlData.away + "-" + dateformaturl
        }
        else {
            lineupPath = '/lineup/' + Utilities.replaceAll(urlData.collection_name, ' ', '_')
        }

        this.props.history.push({ pathname: lineupPath.toLowerCase(), state: { FixturedContest: FixturedContestItem, LobyyData: this.state.LobyyData, resetIndex: 1, isCollectionEnable: (Constants.SELECTED_GAMET == Constants.GameType.MultiGame && this.state.LobyyData.match_list && this.state.LobyyData.match_list.length > 1), isReverseF: this.state.showRF } })
    }

    /**
     * @description Method to show progress bar
     * @param {*} join - number of user joined
     * @param {*} total - total (max size) of team
     */
    ShowProgressBar = (join, total) => {
        return join * 100 / total;
    }

    /**
     * @description method to display contest detail model
     * @param data - contest model data for which contest detail to be shown
     * @param activeTab -  tab to be open on detail, screen
     * @param event -  click event
     */
    ContestDetailShow = (data, activeTab, event) => {
        event.stopPropagation();
        event.preventDefault();
        this.setState({
            showContestDetail: true,
            FixtureData: data,
            activeTab: activeTab,
        });
    }
    /**
     * @description method to hide contest detail model
     */
    ContestDetailHide = () => {
        this.setState({
            showContestDetail: false,
        });
    }

    /**
     * @description method to submit user entry to join contest
     * if user is guest then loggin screen will display else go to roster to select play to create new team
     */
    onSubmitBtnClick = () => {
        if (!WSManager.loggedIn()) {
            setTimeout(() => {
                this.props.history.push({ pathname: '/signup' })
                Utilities.showToast(AppLabels.Please_Login_Signup_First, 3000);
            }, 10);
        } else {
            if (this.state.TeamList != null && !_isUndefined(this.state.TeamList) && this.state.TeamList.length > 0) {
                this.ContestDetailHide();
                setTimeout(() => {
                    this.setState({ showConfirmationPopUp: true, FixtureData: this.state.FixtureData })
                }, 200);
            } else {
                let urlData = this.state.LobyyData;
                let dateformaturl = Utilities.getUtcToLocal(urlData.season_scheduled_date);
                dateformaturl = new Date(dateformaturl);
                let dateformaturlDate = ("0" + dateformaturl.getDate()).slice(-2)
                let dateformaturlMonth = ("0" + (dateformaturl.getMonth() + 1)).slice(-2)
                dateformaturl = dateformaturlDate + '-' + dateformaturlMonth + '-' + dateformaturl.getFullYear();

                let lineupPath = '';
                if (urlData.home) {
                    lineupPath = '/lineup/' + urlData.home + "-vs-" + urlData.away + "-" + dateformaturl
                    this.props.history.push({ pathname: lineupPath.toLowerCase(), state: { FixturedContest: this.state.FixtureData, LobyyData: this.state.LobyyData, resetIndex: 1, isReverseF: this.state.showRF } })
                }
                else {
                    let pathurl = Utilities.replaceAll(urlData.collection_name, ' ', '_');
                    lineupPath = '/lineup/' + pathurl + "-" + dateformaturl
                    this.props.history.push({ pathname: lineupPath.toLowerCase(), state: { FixturedContest: this.state.FixtureData, LobyyData: this.state.LobyyData, resetIndex: 1, isReverseF: this.state.showRF } })
                }
            }
        }
    }

    /**
      * @description method to Sorting by pool Prize
      *
      */
    sortContestsByPoolPrize(contests, sortType = 'reset') {
        if (sortType !== 'reset') {
            contests.sort(function (a, b) {
                if (sortType == 'ASC') {
                    return a.prize_pool - b.prize_pool;
                } else {
                    return a.prize_pool - b.prize_pool > 0 ? -1 : 1;
                }
            });
        }

        return contests;
    }

    /**
     * @description method to contest listing data 
     * @param {*} data - fixture data 
     */
    FixtureContestList(data) {
        let param = {
            "sports_id": Sports[data.sportsId ? data.sportsId : AppSelectedSport],
            "collection_master_id": data.collection_master_id
        }
        if (Constants.SELECTED_GAMET != Constants.GameType.MultiGame) {
            WSManager.setPickedGameType(Constants.GameType.DFS);
        }
        if (param.sports_id) {
            ls.set('selectedSports', param.sports_id.toString() || param.sports_id);
            setValue.setAppSelectedSport(param.sports_id);
        }
        this.setState({ isListLoading: true })
        getFixtureContestList(param).then((responseJson) => {
            if (responseJson && responseJson.response_code == WSC.successCode) {
                // let tmpArray = []
                // _Map(responseJson.data.contest, (item, index) => {
                //     tmpArray = [...tmpArray, ...item.contest_list];
                // })

                // tmpArray = this.sortContestsByPoolPrize(tmpArray, 'DESC');
                const contestGroup = [];
                responseJson.data.contest.forEach(element => {
                    if (element.contest_list) {
                        contestGroup.push({
                            ...element, contest_list: this.sortContestsByPoolPrize(element.contest_list, 'DESC')
                        })
                    }
                });

                let tmpArray = []
                _Map(contestGroup, (item, index) => {
                    tmpArray = [...tmpArray, ...item.contest_list];
                })


                this.setFilterItems([...tmpArray,...responseJson.data.pin_contest]);

                this.setState({
                    sortContestList: tmpArray,
                    FixturedContest: contestGroup,
                    // FixturedContest: responseJson.data.contest,
                    SortContestTotal: responseJson.data.total_contest,
                    FixturedContestTotal: responseJson.data.total_contest,
                    FixturedPinContest: responseJson.data.pin_contest,
                    allContestData: responseJson.data
                }, () => {
                    this.setState({
                        isListLoading: false
                    })
                    if (this.state.isFilterApplied) {
                        this.filterContestList({
                            entry_fee_from: this.state.entry_fee_from,
                            entry_fee_to: this.state.entry_fee_to,
                            participants_from: this.state.participants_from,
                            participants_to: this.state.participants_to,
                            prizepool_from: this.state.prizepool_from,
                            prizepool_to: this.state.prizepool_to,
                            isApplied: true
                        })
                    }
                });
            }
        })
    }

    setFilterItems = (tmpArray) => {
        let entry_fee=0,entries=0,winning=0;
        // console.log(tmpArray,'12');
        tmpArray.forEach(element => {
            if (parseInt(element.entry_fee) > entry_fee ) {
                entry_fee = parseInt(element.entry_fee);
            }
            if (parseInt(element.size) > entries) {
                entries = parseInt(element.size);
            }
            if (parseInt(element.prize_pool) > winning) {
                winning = parseInt(element.prize_pool);
            }
        });

         const filters = {
            "winning": {
                "min": 0,
                "max": winning
            },
            "entry_fee": {
                "min": 0,
                "max": entry_fee
            },
            "entries": {
                "min": 0,
                "max": entries
            }
        } 
        this.setState({
            contestListFilterLoader:filters,
            isContestListFilterSet:true
        });
    }

    /**
     * @description method to get fixture detail
     */
    FixtureDetail = async (CollectionData) => {
        if (!this.state.LobyyData.home) {
            let param = {
                "sports_id": Sports[CollectionData.sportsId],
                "collection_master_id": CollectionData.collection_master_id,
            }
            let apiStatus = Constants.SELECTED_GAMET == Constants.GameType.MultiGame ? getFixtureDetailMultiGame : getFixtureDetail
            var api_response_data = await apiStatus(param);
            if (api_response_data) {
                if (_isUndefined(this.props.location.state)) {
                    this.setState({
                        LobyyData: api_response_data
                    })
                }
                this.setState({
                    FixturedDetail: api_response_data,
                })
                if (Constants.SELECTED_GAMET == Constants.GameType.MultiGame) {
                    this.setState({
                        HeaderOption: {
                            back: true,
                            fixture: true,
                            filter: true,
                            hideShadow: this.state.FixturedDetail && this.state.FixturedDetail.match_list && this.state.FixturedDetail.match_list.length > 1 ? true : false,
                            goBackLobby: !_isUndefined(this.props.location.state) ? this.props.location.state.isFromPM : false
                        }
                    })
                }
            }
        }
    }

    getUserLineUpListApi = async (CollectionData) => {
        let param = {
            "collection_master_id": CollectionData.collection_master_id,
        }
        let user_data = ls.get('profile');
        var user_unique_id = 0;
        if (user_data && user_data.user_unique_id) {
            user_unique_id = user_data.user_unique_id;
        }
        var api_response_data = await getUserTeams(param, user_unique_id);
        if (api_response_data) {
            this.setState({
                TotalTeam: api_response_data,
                TeamList: (this.state.allowRevFantasy && Constants.SELECTED_GAMET == Constants.GameType.DFS) ? api_response_data.filter((obj, idx) => {
                    return (this.state.showRF ? obj.is_reverse == "1" : obj.is_reverse != "1")
                }) : api_response_data,
                userTeamListSend: (this.state.allowRevFantasy && Constants.SELECTED_GAMET == Constants.GameType.DFS) ? api_response_data.filter((obj, idx) => {
                    return (this.state.showRF ? obj.is_reverse == "1" : obj.is_reverse != "1")
                }) : api_response_data,
            })

            if (this.state.userTeamListSend) {
                let tempList = [];
                this.state.userTeamListSend.map((data, key) => {

                    tempList.push({ value: data, label: data.team_name })
                    return '';
                })

                this.setState({ userTeamListSend: tempList });
            }
        }
    }

    callAfterAddFundPopup() {
        if (WSManager.getFromConfirmPopupAddFunds()) {
            WSManager.setFromConfirmPopupAddFunds(false);
            setTimeout(() => {
                var contestData = WSManager.getContestFromAddFundsAndJoin();
                this.joinGame(null, contestData.FixturedContestItem, contestData.TeamsSortedArray)
            }, 100);
        }
    }

    ConfirmEvent = (dataFromConfirmPopUp) => {
        if (dataFromConfirmPopUp.lineUpMasterIdArray && dataFromConfirmPopUp.lineUpMasterIdArray.length > 0) {
            this.JoinGameApiCall(dataFromConfirmPopUp)
        } else if ((dataFromConfirmPopUp.selectedTeam.lineup_master_id != null && dataFromConfirmPopUp.selectedTeam.lineup_master_id == "") || dataFromConfirmPopUp.selectedTeam == "") {
            Utilities.showToast(AppLabels.SELECT_NAME_FIRST, 1000);
        } else {
            // this.JoinGameApiCall(dataFromConfirmPopUp)
            Utilities.showToast(AppLabels.SELECT_NAME_FIRST, 1000);
        }

    }

    JoinGameApiCall = (dataFromConfirmPopUp) => {
        var currentEntryFee = 0;
        currentEntryFee = dataFromConfirmPopUp.entryFeeOfContest;
        if (
            (dataFromConfirmPopUp.FixturedContestItem.currency_type == 2 && (parseInt(currentEntryFee) <= parseInt(dataFromConfirmPopUp.balanceAccToMaxPercent))) ||
            (dataFromConfirmPopUp.FixturedContestItem.currency_type != 2 && (parseFloat(currentEntryFee) <= parseFloat(dataFromConfirmPopUp.balanceAccToMaxPercent)))
        ) {
            this.CallJoinGameApi(dataFromConfirmPopUp);
        }
        else {
            if (dataFromConfirmPopUp.FixturedContestItem.currency_type == 2) {
                if (Constants.EnableBuyCoin) {
                    WSManager.setFromConfirmPopupAddFunds(true);
                    WSManager.setContestFromAddFundsAndJoin(dataFromConfirmPopUp)
                    WSManager.setPaymentCalledFrom("ContestListing")
                    this.props.history.push({ pathname: '/buy-coins', contestDataForFunds: dataFromConfirmPopUp, fromConfirmPopupAddFunds: true, state: { isFrom: 'contestList' } });

                }
                else {
                    this.props.history.push({ pathname: '/earn-coins', state: { isFrom: 'lineup-flow' } })
                }
            }

            else {
                WSManager.setFromConfirmPopupAddFunds(true);
                WSManager.setContestFromAddFundsAndJoin(dataFromConfirmPopUp)
                WSManager.setPaymentCalledFrom("ContestListing")
                this.props.history.push({ pathname: '/add-funds', contestDataForFunds: dataFromConfirmPopUp, fromConfirmPopupAddFunds: true, isReverseF: this.state.showRF });
            }
        }
    }

    CallJoinGameApi(dataFromConfirmPopUp) {
        let param = {
            "contest_id": dataFromConfirmPopUp.FixturedContestItem.contest_id,
            "promo_code": dataFromConfirmPopUp.promoCode,
        }
        let IsNetworkContest = this.state.FixtureData.is_network_contest == 1;
        let apiCall = IsNetworkContest ? joinContestNetworkfantasy : joinContest;
        if (dataFromConfirmPopUp.lineUpMasterIdArray && dataFromConfirmPopUp.lineUpMasterIdArray.length > 0) {
            apiCall = IsNetworkContest ? joinContestWithMultiTeamNF : joinContestWithMultiTeam;
            let resultLineup = dataFromConfirmPopUp.lineUpMasterIdArray.map(a => a.lineup_master_id);
            param['lineup_master_id'] = resultLineup
        } else {
            param['lineup_master_id'] = dataFromConfirmPopUp.selectedTeam.value.lineup_master_id
        }

        apiCall(param).then((responseJson) => {
            if (responseJson.response_code == WSC.successCode) {
                this.ConfirmatioPopUpHide();
                if (this.props.location.state.from == 'MyTeams') {
                    this.setState({
                        isNewCJoined: true,
                        //lineup_master_idArray: [],
                        // lineup_master_id: ''
                    })
                } else {
                    this.setState({
                        isNewCJoined: true,
                        lineup_master_idArray: [],
                        // lineup_master_id: ''
                    })
                }
                setTimeout(() => {
                    //Analytics Calling 
                    WSManager.googleTrack(WSC.GA_PROFILE_ID, 'contestjoin');
                    WSManager.googleTrackDaily(WSC.GA_PROFILE_ID, 'contestjoindaily');
                    WSManager.clearLineup();
                    Utilities.showToast(AppLabels.JOIN_SUCCESS_MESSAGE)
                    this.redirectToLobby()
                    this.getUserLineUpListApi({
                        collection_master_id: dataFromConfirmPopUp.FixturedContestItem.collection_master_id
                    })
                }, 300);
                WSManager.clearLineup();
            } else {
                Utilities.showToast(responseJson.global_error != "" ? responseJson.global_error : responseJson.message, 2000);
                const matchParam = this.props.match.params
                this.FixtureContestList(matchParam);
            }
        })
    }

    redirectToLobby = () => {
        this.goToLobby()
    }

    ThankYouModalShow = (data) => {
        this.setState({
            showThankYouModal: true,
        });
    }

    ThankYouModalHide = () => {
        this.setState({
            showThankYouModal: false,
        });
    }

    goBack = () => {
        this.props.history.goBack();
    }

    goToLobby = () => {
        this.setState({
            showThankYouModal: false,
            // lineup_master_id:''
        });
        const matchParam = globalThis.props.match.params
        globalThis.FixtureContestList(matchParam);
    }

    seeMyContest = () => {
        this.props.history.push({ pathname: '/my-contests', state: { from: 'SelectCaptain' } });
    }

    createTeamAndJoin = (dataFromConfirmFixture = "", dataFromConfirmLobby = "") => {
        const CollectionData = this.state.LobyyData;
        if (CollectionData) {
            WSManager.clearLineup();
            let urlParams = '';
            if (Constants.SELECTED_GAMET != Constants.GameType.MultiGame || (Constants.SELECTED_GAMET == Constants.GameType.MultiGame && CollectionData.match_list.length == 1)) {
                urlParams = Utilities.setUrlParams(CollectionData)
            } else {
                urlParams = Utilities.replaceAll(CollectionData.collection_name, ' ', '_')
            }
            this.props.history.push({ pathname: '/lineup/' + urlParams, state: { FixturedContest: CollectionData, LobyyData: CollectionData, from: 'MyTeams', isFromMyTeams: true, isFrom: "MyTeams", resetIndex: 1, isReverseF: this.state.isReverseF } })
        }
    }


    /* Handle contest listing filters */
    hideFilter = () => {
        this.setState({ showContestListFitler: false })
    }

    showFilter = () => {
        this.setState({ showContestListFitler: true })
    }

    filterConditions(filterObj, obj) {
        let eFee = parseInt(obj.entry_fee);
        let partic = parseInt(obj.size);
        // let prize = parseInt(obj.prize_pool);


        let prize_data = obj.prize_distibution_detail ? obj.prize_distibution_detail : obj.prize_distribution_detail;
        let prizeAmount = this.getWinCalculation(prize_data);
        let prize = prizeAmount.real > 0 ? prizeAmount.real : prizeAmount.bonus > 0 ? prizeAmount.bonus : prizeAmount.point;

        let isWinBetween = prizeAmount.is_tie_breaker == 1 ? true : (prize >= filterObj.prizepool_from && prize <= filterObj.prizepool_to)

        return (
            (eFee >= filterObj.entry_fee_from && eFee <= filterObj.entry_fee_to)
            &&
            (partic >= filterObj.participants_from && partic <= filterObj.participants_to)
            &&
            isWinBetween
        )
    }

    filterContestList = (filterObj) => {
        const { allContestData } = this.state
        if (filterObj.isReset) {
            let tmpSortArray = []
            _Map(allContestData.contest, (item) => {
                tmpSortArray = [...tmpSortArray, ...item.contest_list];
            })
            // tmpSortArray = this.sortContestsByPoolPrize(tmpSortArray, 'DESC');

            this.setState({
                showContestListFitler: false,
                sortContestList: tmpSortArray,
                FixturedContest: allContestData.contest,
                SortContestTotal: allContestData.total_contest,
                FixturedContestTotal: allContestData.total_contest,
                FixturedPinContest: allContestData.pin_contest,
                isFilterApplied: false
            });
        } else {
            let cloneAllData = _cloneDeep(allContestData);
            let tmpAllContest = [];
            _Map(cloneAllData.contest, (item) => {
                let filterArray = _filter(item.contest_list, (obj) => {
                    return this.filterConditions(filterObj, obj)
                })
                if (filterArray.length > 0) {
                    item['contest_list'] = filterArray;
                    item['total'] = filterArray.length;
                    tmpAllContest.push(item)
                }
            })
            cloneAllData['contest'] = tmpAllContest;



            // tmpArray = this.sortContestsByPoolPrize(tmpArray, 'DESC');

            const contestGroup = [];
            cloneAllData.contest.forEach(element => {
                if (element.contest_list) {
                    contestGroup.push({
                        ...element, contest_list: this.sortContestsByPoolPrize(element.contest_list, 'DESC')
                    })
                }
            });
            let tmpArray = []
            _Map(contestGroup, (item, index) => {
                tmpArray = [...tmpArray, ...item.contest_list];
            })

            let filterPINArray = _filter(cloneAllData.pin_contest, (obj) => {
                return this.filterConditions(filterObj, obj)
            })

            this.setState({
                showContestListFitler: false,
                sortContestList: tmpArray,
                FixturedContest: contestGroup,
                // FixturedContest: cloneAllData.contest,
                SortContestTotal: tmpArray.length + filterPINArray.length,
                FixturedContestTotal: tmpArray.length + filterPINArray.length,
                FixturedPinContest: filterPINArray,
                isFilterApplied: true
            });
        }
        this.setState({
            entry_fee_from: filterObj.entry_fee_from,
            entry_fee_to: filterObj.entry_fee_to,
            participants_from: filterObj.participants_from,
            participants_to: filterObj.participants_to,
            prizepool_from: filterObj.prizepool_from,
            prizepool_to: filterObj.prizepool_to
        });
    }

    getContestWinnerCount(prizeDistributionDetail) {
        if (prizeDistributionDetail.length > 0) {
            if ((prizeDistributionDetail[prizeDistributionDetail.length - 1].max) > 1) {
                return prizeDistributionDetail[prizeDistributionDetail.length - 1].max + " " + AppLabels.WINNERS
            } else {
                return prizeDistributionDetail[prizeDistributionDetail.length - 1].max + " " + AppLabels.WINNER;
            }
        }
    }

    redirectToMyTeams() {
        if (this.state.userTeamListSend.length > 0) {
            let urlParams = '';
            if (this.state.LobyyData && this.state.LobyyData.home) {
                urlParams = Utilities.setUrlParams(this.state.LobyyData);
            }
            else {
                urlParams = Utilities.replaceAll(this.state.LobyyData.collection_name, ' ', '_').toLowerCase();
            }

            let sportsId = Utilities.getSelectedSportsForUrl();
            let collection_master_id = this.state.LobyyData.collection_master_id;
            let keyName = 'my-teams' + sportsId + collection_master_id;
            if (this.state.isNewCJoined) {
                preTeamsList[keyName] = [];
            } else {
                preTeamsList[keyName] = this.state.TeamList;
            }
            this.props.history.push({ pathname: "/" + sportsId + '/my-teams/' + collection_master_id + "/" + urlParams, state: { LobyyData: this.state.LobyyData, isReverseF: this.state.showRF, TotalTeam: this.state.TotalTeam } });

        } else {
            let urlData = this.state.LobyyData;
            WSManager.clearLineup()
            let dateformaturl = Utilities.getUtcToLocal(urlData.season_scheduled_date);
            dateformaturl = new Date(dateformaturl);
            dateformaturl = dateformaturl.getDate() + '-' + (dateformaturl.getMonth() + 1) + '-' + dateformaturl.getFullYear();
            if (urlData.home) {
                this.props.history.push({ pathname: '/lineup/' + urlData.home.toLowerCase() + "-vs-" + urlData.away.toLowerCase() + "-" + dateformaturl, state: { FixturedContest: this.state.LobyyData, LobyyData: this.state.LobyyData, from: 'MyTeams', isFromMyTeams: true, isFrom: "MyTeams", resetIndex: 1, isReverseF: this.state.showRF } })
            }
            else {
                let collectionName = Utilities.replaceAll(urlData.collection_name, ' ', '_');
                this.props.history.push({ pathname: '/lineup/' + collectionName.toLowerCase() + "-" + dateformaturl, state: { FixturedContest: this.state.LobyyData, LobyyData: this.state.LobyyData, from: 'MyTeams', isFromMyTeams: true, isFrom: "MyTeams", resetIndex: 1, isReverseF: this.state.showRF } })
            }
        }
    }

    showDetail(Group, index) {
        Group.isReadMore = true;
        var arrFixture = this.state.FixturedContest;
        arrFixture[index] = Group;
        this.setState({ FixturedContest: arrFixture });
    }

    hideDetail(Group, index) {
        Group.isReadMore = undefined;
        var arrFixture = this.state.FixturedContest;
        arrFixture[index] = Group;
        this.setState({ FixturedContest: arrFixture });
    }

    renderContestView(data) {
        let { contest, isPinned, isGroup } = data;
        let sponserImage = data.contest.sponsor_logo && data.contest.sponsor_logo != null ? data.contest.sponsor_logo : 0;
        let remainingJoinCount = (contest.size || 0) - (contest.total_user_joined || 0);
        let lineupAryLength = this.state.lineup_master_idArray.length;
        let user_join_count = parseInt(contest.user_joined_count || 0);
        let ContestDisabled = lineupAryLength > 1 ? (lineupAryLength > remainingJoinCount || ((lineupAryLength + user_join_count) > contest.multiple_lineup) || contest.multiple_lineup <= 1) : false;
        return (
            <div className={"contest-container" + (ContestDisabled ? ' disabled-contest' : '')}>
                {/*Card Header Starts*/}
                <div className="contest-header" onClick={(event) => (ContestDisabled) ? null : globalThis.ContestDetailShow(contest, 2, event)}>
                    <div className="flex-row-center">
                        {isPinned &&
                            <div className="flex-row-center pointer">
                                <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={
                                    <Tooltip id="tooltip" className="tooltip-featured">
                                        <strong>{AppLabels.TRENDING_DESCRIPTION}</strong>
                                    </Tooltip>
                                }>
                                    <span className="contest-icon" onClick={(e) => e.stopPropagation()}><MaterialIcon icon="trending_up" size={12} color="#FFFFFF" /></span>
                                </OverlayTrigger>
                                <span className="contest-icon-description">{/*AppLabels.TRENDING*/}</span>
                            </div>
                        }

                        {contest.guaranteed_prize == 2 && parseInt(contest.total_user_joined) >= parseInt(contest.minimum_size) &&
                            <div className="flex-row-center pointer">
                                <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={
                                    <Tooltip id="tooltip" className="tooltip-featured">
                                        <strong>{AppLabels.GUARANTEED_DESCRIPTION}</strong>
                                    </Tooltip>
                                }>
                                    <span className="contest-icon" onClick={(e) => e.stopPropagation()}>g</span>
                                </OverlayTrigger>
                                <span className="contest-icon-description">{/*AppLabels.GUARANTEED*/}</span>
                            </div>
                        }
                        {contest.is_confirmed == 1 && parseInt(contest.total_user_joined) >= parseInt(contest.minimum_size) &&
                            <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={
                                <Tooltip id="tooltip" className="tooltip-featured">
                                    <strong>{AppLabels.CONFIRM_DESCRIPTION}</strong>
                                </Tooltip>
                            }>
                                <span className="contest-icon" onClick={(e) => e.stopPropagation()}>c</span>
                            </OverlayTrigger>
                        }
                        {contest.multiple_lineup > 1 ?
                            <div className="flex-row-center pointer">
                                <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={
                                    <Tooltip id="tooltip" className="tooltip-featured">
                                        <strong>{AppLabels.MAX_TEAM_FOR_MULTI_ENTRY} {contest.multiple_lineup} {AppLabels.MAX_MULTI_ENTRY_TEAM}</strong>
                                    </Tooltip>
                                }>
                                    <span className="contest-icon" onClick={(e) => e.stopPropagation()}>m</span>
                                </OverlayTrigger>
                                <span className="contest-icon-description">{AppLabels.UPTO} {contest.multiple_lineup}</span>
                            </div>
                            :
                            <div className="flex-row-center pointer">
                                <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={
                                    <Tooltip id="tooltip" className="tooltip-featured">
                                        <strong>{AppLabels.SINGLE_TEAM_DESCRIPTION}</strong>
                                    </Tooltip>
                                }>
                                    <span className="contest-icon" onClick={(e) => e.stopPropagation()}>s</span>
                                </OverlayTrigger>
                                <span className="contest-icon-description">{/*AppLabels.SINGLE*/}</span>
                            </div>
                        }
                    </div>
                    <div>
                        <i onClick={(shareContestEvent) => globalThis.shareContest(shareContestEvent, contest)} style={{ cursor: 'pointer' }} className="icon-share"></i>
                    </div>
                </div>
                {/* Card Header Ends */}

                {/* Card Body Starts */}
                <div className="contest-body" onClick={(event) => (ContestDisabled) ? null : globalThis.ContestDetailShow(contest, 2, event)}>
                    <div className="contest-body-top">
                        <div>
                            <div onClick={(event) => globalThis.ContestDetailShow(contest, 1, event)} className="heading">{contest.contest_title ? '' : AppLabels.WIN + " "}{contest.contest_title ? contest.contest_title : this.getPrizeAmount(contest.prize_distibution_detail)}</div>
                            {
                                Constants.OnlyCoinsFlow != 1 && contest.max_bonus_allowed != '0' &&
                                <div className="text-small-italic mt3x">
                                    <span onClick={(event) => globalThis.ContestDetailShow(contest, 1, event)}>
                                        {AppLabels.Use} {contest.max_bonus_allowed}{'% '}{AppLabels.BONUS_CASH_CONTEST_LISTING}
                                    </span>
                                </div>
                            }
                        </div>
                        <Button className="contest-button" onClick={(event) => globalThis.check(event, contest)}>
                            {
                                contest.entry_fee > 0 ? ((contest.prize_type == 1 || contest.prize_type == 0) ?
                                    <React.Fragment>
                                        {
                                            contest.currency_type == 2 ?
                                                <img className="img-coin" alt='' src={Images.IC_COIN} />
                                                :
                                                <span>
                                                    {Utilities.getMasterData().currency_code}
                                                    {/* {AppLabels.JOIN + "  " + Utilities.getMasterData().currency_code + contest.entry_fee} */}
                                                </span>
                                        }
                                        {contest.entry_fee}
                                    </React.Fragment>
                                    :
                                    <React.Fragment>
                                        <span >
                                            {/* {AppLabels.JOIN}&nbsp; */}
                                            <i className="icon-bean"></i>
                                        </span>
                                        {contest.entry_fee}
                                    </React.Fragment>
                                ) : AppLabels.FREE
                            }
                        </Button>
                    </div>
                    <div className="contest-body-bottom" onClick={(event) => globalThis.ContestDetailShow(contest, 3, event)}>
                        <div className="progress-bar-default">
                            <ProgressBar now={this.ShowProgressBar(contest.total_user_joined, contest.minimum_size)} className={parseInt(contest.total_user_joined) >= parseInt(contest.minimum_size) ? '' : 'danger-area'} />
                            <div className="footer">
                                <span>
                                    <span style={{ fontSize: 12 }}>{contest.total_user_joined}</span>
                                    <span style={{ fontSize: 12 }}> / {contest.size} {AppLabels.ENTRIES}</span>
                                </span>
                                <span style={{ fontSize: 12, textTransform: 'lowercase' }}>{AppLabels.MIN} {contest.minimum_size} {AppLabels.ENTRIES}</span>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Card Body Ends */}

                {/* Card Footer Starts */}
                {sponserImage != 0 &&
                    <div className="sponsor-logo-section" style={{ textAlign: "center" }}>
                        {Constants.SELECTED_GAMET == Constants.GameType.DFS &&
                            window.ReactNativeWebView && !this.checkSponserUrlDomain(contest.sponsor_link, process.env.REACT_APP_BASE_URL) ?
                            <a
                                href
                                onClick={(event) => Utilities.callNativeRedirection(Utilities.getValidSponserURL(contest.sponsor_link), event)}
                                className="attached-url">
                                <img alt='' className="lobby_sponser-image" style={{ resizeMode: 'contain', objectFit: "contain", width: "80%" }} src={sponserImage == 0 ? '' : Utilities.getSponserURL(sponserImage)} />
                            </a>
                            :
                            <a
                                href={Utilities.getValidSponserURL(contest.sponsor_link)}
                                onClick={(event) => event.stopPropagation()}
                                target='__blank'
                                className="attached-url">
                                <img alt='' className="lobby_sponser-image" style={{ resizeMode: 'contain', objectFit: "contain", maxWidth: "90%" }} src={sponserImage == 0 ? '' : Utilities.getSponserURL(sponserImage)} />
                            </a>
                        }
                    </div>}
                {/* Card Footer Ends */}
            </div>
        );

    }

    renderContestViewOld(data) {
        let { contest, isPinned, isGroup } = data;
        let sponserImage = data.contest.sponsor_logo && data.contest.sponsor_logo != null ? data.contest.sponsor_logo : 0;
        let remainingJoinCount = (contest.size || 0) - (contest.total_user_joined || 0);
        let lineupAryLength = this.state.lineup_master_idArray.length;
        let user_join_count = parseInt(contest.user_joined_count || 0);
        let ContestDisabled = lineupAryLength > 1 ? (lineupAryLength > remainingJoinCount || ((lineupAryLength + user_join_count) > contest.multiple_lineup) || contest.multiple_lineup <= 1) : false;
        return (
            <div className={"contest-list" + (isGroup ? ' contest-card-body' : ' position-relative') + (isPinned ? ' pinned' : '')}>
                <div className={"contest-list-header" + (ContestDisabled ? ' disabled-contest-card' : '')} onClick={(event) => (ContestDisabled) ? null : globalThis.ContestDetailShow(contest, 2, event)}>


                    <div className="contest-heading">
                        {
                            isPinned && <div className="contest-pin">
                                <img alt='' src={Images.pinned_ic}>

                                </img>
                            </div>
                        }
                        {contest.multiple_lineup > 1 &&
                            <OverlayTrigger trigger={['hover', 'focus']} placement="left" overlay={
                                <Tooltip id="tooltip" className="tooltip-featured">
                                    <strong>{AppLabels.MAX_TEAM_FOR_MULTI_ENTRY} {contest.multiple_lineup} {AppLabels.MAX_MULTI_ENTRY_TEAM}</strong>
                                </Tooltip>
                            }>
                                <span className="featured-icon" onClick={(e) => e.stopPropagation()}>m</span>
                            </OverlayTrigger>

                        }
                        {
                            contest.guaranteed_prize == 2 && parseInt(contest.total_user_joined) >= parseInt(contest.minimum_size) &&
                            <OverlayTrigger trigger={['hover', 'focus']} placement="left" overlay={
                                <Tooltip id="tooltip" className="tooltip-featured">
                                    <strong>{AppLabels.GUARANTEED_DESCRIPTION}</strong>
                                </Tooltip>
                            }>
                                <span className="featured-icon" onClick={(e) => e.stopPropagation()}>g</span>
                            </OverlayTrigger>

                        }
                        {
                            contest.is_confirmed == 1 && parseInt(contest.total_user_joined) >= parseInt(contest.minimum_size) &&
                            <OverlayTrigger trigger={['hover', 'focus']} placement="left" overlay={
                                <Tooltip id="tooltip" className="tooltip-featured">
                                    <strong>{AppLabels.CONFIRM_DESCRIPTION}</strong>
                                </Tooltip>
                            }>
                                <span className="featured-icon" onClick={(e) => e.stopPropagation()}>c</span>
                            </OverlayTrigger>

                        }


                        <h3 className="win-type">
                            {
                                <React.Fragment>
                                    <span onClick={(event) => globalThis.ContestDetailShow(contest, 1, event)}>
                                        <span className="prize-pool-text text-capitalize" >{contest.contest_title ? '' : AppLabels.WIN} </span>

                                        <span>
                                            {contest.contest_title ? contest.contest_title : this.getPrizeAmount(contest.prize_distibution_detail)}
                                        </span>

                                        {contest.prize_type == 2 &&
                                            <span className='prize-pool-value'>
                                                {contest.prize_pool != "0" && <img src={Images.COINS} alt="" />}
                                                {contest.prize_pool == "0" ? ' ' + AppLabels.PRACTICE : contest.prize_pool}</span>
                                        }
                                    </span>
                                    {/* {
                                        (Constants.SELECTED_GAMET != Constants.GameType.MultiGame
                                            && !contest.is_network_contest && */}
                                    <i onClick={(shareContestEvent) => globalThis.shareContest(shareContestEvent, contest)} className="icon-share"></i>

                                    {/* )
                                    } */}
                                </React.Fragment>
                            }

                        </h3>
                        {
                            Constants.OnlyCoinsFlow != 1 && contest.max_bonus_allowed != '0' &&
                            <div className="text-small-italic mt3x">
                                <span onClick={(event) => globalThis.ContestDetailShow(contest, 1, event)}>
                                    {AppLabels.Use} {contest.max_bonus_allowed}{'% '}{AppLabels.BONUS_CASH_CONTEST_LISTING}
                                </span>
                            </div>
                        }

                    </div>
                    <div className="display-table">
                        <div className="progress-bar-default display-table-cell v-mid" onClick={(event) => globalThis.ContestDetailShow(contest, 3, event)}>
                            <ProgressBar now={this.ShowProgressBar(contest.total_user_joined, contest.minimum_size)} className={parseInt(contest.total_user_joined) >= parseInt(contest.minimum_size) ? '' : 'danger-area'} />
                            <div className="progress-bar-value" >
                                <span className="user-joined">{contest.total_user_joined}</span><span className="total-entries"> / {contest.size} {AppLabels.ENTRIES} </span>
                                <span className="min-entries">{AppLabels.MIN} {contest.minimum_size}</span>
                            </div>
                            <div>
                                {contest.multiple_lineup > 1 && <span style={{ color: "#23416a", fontSize: "11px" }}>Upto {contest.multiple_lineup} teams per user</span>}
                            </div>
                        </div>
                        <div className="display-table-cell v-mid position-relative entry-criteria">
                            <Button className="white-base btnStyle btn-rounded" bsStyle="primary" onClick={(event) => globalThis.check(event, contest)}>
                                {
                                    contest.entry_fee > 0 ? ((contest.prize_type == 1 || contest.prize_type == 0) ?
                                        <React.Fragment>
                                            {
                                                contest.currency_type == 2 ?
                                                    <img className="img-coin" alt='' src={Images.IC_COIN} />
                                                    :
                                                    <span>
                                                        {Utilities.getMasterData().currency_code}
                                                        {/* {AppLabels.JOIN + "  " + Utilities.getMasterData().currency_code + contest.entry_fee} */}
                                                    </span>
                                            }
                                            {contest.entry_fee}
                                        </React.Fragment>
                                        :
                                        <React.Fragment>
                                            <span >
                                                {/* {AppLabels.JOIN}&nbsp; */}
                                                <i className="icon-bean"></i>
                                            </span>
                                            {contest.entry_fee}
                                        </React.Fragment>
                                    ) : AppLabels.FREE
                                }
                            </Button>
                        </div>

                    </div>
                    {
                        data.contest.sponsor_logo && data.contest.sponsor_logo != null &&
                        <div className={"contest-card-footer" + (Constants.SELECTED_GAMET == Constants.GameType.DFS ? ' height-sponsor-strip' : '')}>
                            {/* {
                                <div className="sponser-by-text">
                                    {AppLabels.SPONSORED_BY}

                                </div>
                            } */}
                            <div className="sponsor-logo-section">
                                {Constants.SELECTED_GAMET == Constants.GameType.DFS &&
                                    window.ReactNativeWebView && !this.checkSponserUrlDomain(data.contest.sponsor_link, process.env.REACT_APP_BASE_URL) ?
                                    <a
                                        href
                                        onClick={(event) => Utilities.callNativeRedirection(Utilities.getValidSponserURL(data.contest.sponsor_link), event)}
                                        className="attached-url">
                                        <img alt='' className="lobby_sponser-image" style={{ resizeMode: 'contain' }} src={sponserImage == 0 ? '' : Utilities.getSponserURL(sponserImage)} />
                                    </a>
                                    :
                                    <a
                                        href={Utilities.getValidSponserURL(data.contest.sponsor_link)}
                                        onClick={(event) => event.stopPropagation()}
                                        target='__blank'
                                        className="attached-url">
                                        <img alt='' className="lobby_sponser-image" style={{ resizeMode: 'contain' }} src={sponserImage == 0 ? '' : Utilities.getSponserURL(sponserImage)} />
                                    </a>
                                }
                            </div>

                        </div>
                    }
                    {/* <div className="footer-sponser-img"></div> */}
                </div>
            </div>
        );

    }

    getWinCalculation = (prize_data) => {
        let prizeAmount = { 'real': 0, 'bonus': 0, 'point': 0, 'is_tie_breaker': 0 };
        prize_data && prize_data.map(function (lObj, lKey) {
            var amount = 0;
            if (lObj.max_value) {
                amount = parseFloat(lObj.max_value);
            } else {
                amount = parseFloat(lObj.amount);
            }
            if (lObj.prize_type == 3) {
                prizeAmount['is_tie_breaker'] = 1;
            }
            if (lObj.prize_type == 0) {
                prizeAmount['bonus'] = parseFloat(prizeAmount['bonus']) + amount;
            } else if (lObj.prize_type == 2) {
                prizeAmount['point'] = parseFloat(prizeAmount['point']) + amount;
            } else {
                prizeAmount['real'] = parseFloat(prizeAmount['real']) + amount;
            }
        })
        return prizeAmount;
    }

    getPrizeAmount = (prize_data) => {
        let prizeAmount = this.getWinCalculation(prize_data);
        return (
            <React.Fragment>
                {
                    prizeAmount.is_tie_breaker == 0 && prizeAmount.real > 0 ?
                        <span className="contest-prizes">{Utilities.getMasterData().currency_code}{parseFloat(prizeAmount.real).toFixed(0)}</span>
                        : prizeAmount.is_tie_breaker == 0 && prizeAmount.bonus > 0 ? <div className="contest-listing-prizes" ><i className="icon-bonus" />{parseFloat(prizeAmount.bonus).toFixed(0)}</div>
                            : prizeAmount.is_tie_breaker == 0 && prizeAmount.point > 0 ? <span style={{ display: 'inlineBlock' }}> <img className="img-coin" alt='' src={Images.IC_COIN} />{parseFloat(prizeAmount.point).toFixed(0)}</span>
                                : AppLabels.PRIZES
                }
            </React.Fragment>
        )


    }

    showDownloadApp = () => {
        this.ConfirmatioPopUpHide();
        this.setState({
            showDAM: true
        })
    }

    hideDownloadApp = () => {
        this.setState({
            showDAM: false
        })
    }
    openAlert = () => {
        this.setState({
            showAlert: true
        })
    }

    hideAlert = () => {
        this.setState({
            showAlert: false
        })
    }

    showRFNotPlayingModal = (FixturedContestItem) => {
        this.setState({
            showRFNPP: true,
            openContest: FixturedContestItem
        })
    }
    hideRFNotPlayingModal = () => {
        this.setState({
            showRFNPP: false
        }, () => {
            this.goToLineup(this.state.openContest)
        })
    }

    showRFContest = () => {
        this.setState({
            isLoading: false,
            showRF: true
        }, () => {
            this.setState({
                isLoading: true
            })
            const matchParam = this.props.match.params;
            Constants.setValue.SetRFContestId(matchParam.collection_master_id);
            this.setState({
                lineup_master_id: '',
                lineup_master_idArray: []
            })
            this.FixtureDetail(matchParam);
            if (WSManager.loggedIn()) {
                this.getUserLineUpListApi(matchParam);
            }
            this.FixtureContestList(matchParam);
        })
    }
    showNCAContest = () => {
        this.setState({
            isLoading: false,
            showRF: false
        }, () => {
            this.setState({
                isLoading: true
            })
            const matchParam = this.props.match.params;
            Constants.setValue.SetRFContestId('');
            this.setState({
                lineup_master_id: '',
                lineup_master_idArray: []
            })
            this.FixtureDetail(matchParam);
            if (WSManager.loggedIn()) {
                this.getUserLineUpListApi(matchParam);
            }
            this.FixtureContestList(matchParam);
        })
    }

    getFixtureModalData = () => {
        if (this.state.lineup_master_idArray.length > 0 && this.state.FixtureData) {
            const returnData = _cloneDeep(this.state.FixtureData);
            returnData['entry_fee'] = returnData.entry_fee * this.state.lineup_master_idArray.length;
            return returnData
        } else {
            return this.state.FixtureData
        }
    }
    checkSponserUrlDomain = (sponserUrl, baseUrl) => {
        var isPathSame = false;
        const sponserUrlPath = new URL('', sponserUrl);
        const baseUrlPath = new URL('', baseUrl);
        if (sponserUrlPath.hostname == baseUrlPath.hostname) {
            isPathSame = true;
        }
        return isPathSame;

    }

    handleSortSelect = sort => {
        const { sortContestList } = this.state
        let newList = []
        switch (sort) {
            case "Default":
                newList = sortContestList.sort((a, b) => a.group_id - b.group_id)
                break;

            case "Group":
                newList = sortContestList.sort((a, b) => a.group_id - b.group_id)
                break;

            case "Prize Pool":
                newList = sortContestList.sort((a, b) => b.prize_pool - a.prize_pool)
                break;

            case "Entry Fee":
                newList = sortContestList.sort((a, b) => a.entry_fee - b.entry_fee)
                break;

            default:
                break;
        }
        this.setState({
            selectedSort: sort,
            sortContestList: newList
        })
        ls.set("selected_sort", sort)
    }

    render() {
        const {
            showContestDetail,
            showConfirmationPopUp,
            userTeamListSend,
            LobyyData,
            showSharContestModal,
            activeTab,
            showLoadMore,
            FixturedContestTotal,
            SortContestTotal,
            showThankYouModal,
            hasMore,
            LoaderShow,
            currentlySelectedGroup,
            currentlySelectedGroupItems,
            selectedSort,
            showCollectionInfo,
            isFilterApplied,
            sortContestList,
            FixturedContest,
            FixturedPinContest,
            HeaderOption,
            FixturedDetail,
            showContestListFitler,
            entry_fee_from,
            entry_fee_to,
            participants_from,
            participants_to,
            prizepool_from,
            prizepool_to,
            isListLoading,
            ShimmerList,
            showDAM,
            showRF,
            allowRevFantasy,
            showRFNPP,
            TotalTeam,
            showAlert,
            contestListFilterLoader,
            isContestListFilterSet
        } = this.state;

        const FitlerOptions = {
            showContestListFitler: showContestListFitler,
            entry_fee_from: entry_fee_from,
            entry_fee_to: entry_fee_to,
            participants_from: participants_from,
            participants_to: participants_to,
            prizepool_from: prizepool_from,
            prizepool_to: prizepool_to
        }

        let showMyTeamBtn = true;
        let FixtureData = this.getFixtureModalData();
        if (this.props.location.state && this.props.location.state.from == 'MyTeams' && this.state.lineup_master_id != '') {
            showMyTeamBtn = false;
        }
        return (
            <MyContext.Consumer>
                {(context) => (
                    <div className={"web-container contest-listing-web-conatiner header-margin minus-header-height " + (Constants.SELECTED_GAMET == Constants.GameType.MultiGame && FixturedDetail && FixturedDetail.match_list && FixturedDetail.match_list.length > 1 ? '  contest-listing-web-collection' : '')}>
                        <Helmet titleTemplate={`${MetaData.template} | %s`}>
                            <title>{MetaData.contestListing.title}</title>
                            <meta name="description" content={MetaData.contestListing.description} />
                            <meta name="keywords" content={MetaData.contestListing.keywords}></meta>
                        </Helmet>

                        <CustomHeader
                            LobyyData={LobyyData}
                            ref={(ref) => this.headerRef = ref}
                            HeaderOption={HeaderOption}
                            {...this.props}
                            showLobbyFitlers={this.showFilter} />

                        {isContestListFilterSet && <Filter
                            {...this.props}
                            FitlerOptions={FitlerOptions}
                            contestListFilterLoader={contestListFilterLoader}
                            hideFilter={this.hideFilter}
                            filterContestList={this.filterContestList}></Filter>}

                        <div className="webcontainer-inner">
                            {
                                Constants.SELECTED_GAMET == Constants.GameType.MultiGame &&
                                <CollectionSlider
                                    contestSliderData={FixturedDetail}
                                    collectionInfo={true}
                                    isFrom={"ContestListing"}
                                    CollectionInfoShow={this.CollectionInfoShow} />
                            }

                            {LobyyData && LobyyData.custom_message != '' && LobyyData.custom_message != null &&
                                <div className="">
                                    <Alert variant="warning" className="alert-warning msg-alert-container border-radius-0">
                                        <div className="msg-alert-wrapper">
                                            <span className=""><i className="icon-megaphone"></i></span>
                                            <span>{LobyyData.custom_message}</span>
                                        </div>
                                    </Alert>
                                </div>
                            }
                            <Row>
                                <Col sm={12}>
                                    <div className={selectedSort == "Group" ? "contest-sort-container-group" : "contest-sort-container"}>
                                        <div>Sort By:</div>
                                        <div className="contest-sort-item-container">
                                            {sorting.map(sort =>
                                                <div className={selectedSort == sort ? "contest-sort-item-selected" : "contest-sort-item"} onClick={() => (selectedSort == sort ? '' : this.handleSortSelect(sort))}>{sort}</div>
                                            )}
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            {
                                selectedSort == "Group" &&
                                <Row>
                                    <Col sm={12}>
                                        <div className="sort-group-container">
                                            <div className="sort-group-item-container">
                                                {groups.map(group =>
                                                    <div className={currentlySelectedGroup == group.name ? "sort-group-item-selected" : "sort-group-item"} onClick={() => { this.setState({ currentlySelectedGroup: group.name, currentlySelectedGroupItems: group.items }); ls.set("currently_selected_group", group.name); ls.set("currently_selected_group_items", group.items) }}>{group.name}</div>
                                                )}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            }
                            <Row>
                                <Col sm={12}>
                                    <InfiniteScroll
                                        dataLength={selectedSort == "Group" ? FixturedContest.length : sortContestList.length}
                                        pullDownToRefreshThreshold={300}
                                        refreshFunction={!showContestDetail && this.handleRefresh}
                                        // pullDownToRefresh={window.ReactNativeWebView || isMobile ? true : false}
                                        pullDownToRefresh={false}
                                        hasMore={hasMore}
                                        loader={
                                            LoaderShow == true &&
                                            <h4 className='table-loader'>{AppLabels.LOADING_MSG}</h4>
                                        }
                                        pullDownToRefreshContent={
                                            // window.ReactNativeWebView || isMobile &&
                                            <h3 style={{ textAlign: 'center', fontSize: 14 }}>&#8595; {AppLabels.PULL_DOWN_TO_REFRESH}</h3>
                                        }
                                        releaseToRefreshContent={
                                            // window.ReactNativeWebView || isMobile &&
                                            <h3 style={{ textAlign: 'center', fontSize: 14 }}>&#8593; {AppLabels.RELEASE_TO_REFRESH}</h3>
                                        }>

                                        {
                                            _Map(FixturedPinContest, (contest, index) => {
                                                return (
                                                    currentlySelectedGroupItems.includes(contest.group_id) &&
                                                    <div className="contest-list-wrapper mt20 mb20" key={index} >
                                                        {this.renderContestView({ index: index, contest: contest, isPinned: true })}
                                                    </div>
                                                )
                                            })
                                        }

                                        {selectedSort == "Group" && _Map(FixturedContest, (group, idx) => {
                                            var arrGroupList = [];
                                            if (group.contest_list.length > 2 && group.isReadMore == undefined) {
                                                arrGroupList.push(group.contest_list[0]);
                                                arrGroupList.push(group.contest_list[1]);
                                            } else {
                                                arrGroupList = group.contest_list;
                                            }
                                            return (
                                                (currentlySelectedGroupItems.includes(group.group_id) || currentlySelectedGroup == 'All') ?
                                                    <div className="contest-list-wrapper mt20 mb20" key={idx}>
                                                        <div className={"contest-listing-card" + (showLoadMore && group.total > 2 ? ' more-contest-card' : '')}>
                                                            <div className="contest-listing-card-header">
                                                                <img src={Images.S3_BUCKET_IMG_PATH + group.icon} alt="" className="contest-img" />
                                                                <div className="contest-name-heading">{group.group_name}</div>
                                                                <div className="contest-name-heading-description">{group.description}</div>
                                                            </div>
                                                            {
                                                                _Map(arrGroupList, (contest, index) => {
                                                                    return (
                                                                        <div key={index} >
                                                                            {this.renderContestView({ index: index, contest: contest, isGroup: true, })}
                                                                        </div>
                                                                    )
                                                                })
                                                            }

                                                            {group.total > 2 && group.isReadMore == undefined &&
                                                                <div className="text-center show-more-contest" onClick={() => this.showDetail(group, idx)}>
                                                                    {AppLabels.MORE_CONTEST}<i className="icon-arrow-down"></i>
                                                                </div>
                                                            }

                                                            {group.total > 2 && group.isReadMore == true &&
                                                                <div className="text-center show-more-contest" onClick={() => this.hideDetail(group, idx)}>
                                                                    {AppLabels.LESS_CONTEST}<i className="icon-arrow-up"></i>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                    :
                                                    <></>
                                            );
                                        })
                                        }
                                        {
                                            selectedSort !== "Group" && _Map(sortContestList, (contest, index) => {
                                                return (
                                                    <div className="contest-list-wrapper mt20 mb20" key={index} >
                                                        {this.renderContestView({ index: index, contest: contest })}
                                                    </div>
                                                )
                                            })
                                        }
                                        {
                                            FixturedContest.length == 0 && FixturedPinContest.length == 0 && !isListLoading &&
                                            <NoDataView
                                                BG_IMAGE={Images.no_data_bg_image}
                                                CENTER_IMAGE={Images.BRAND_LOGO_FULL}
                                                MESSAGE_1={isFilterApplied ? AppLabels.NO_RESULT_FOUND_FILTER_1 : AppLabels.NO_FIXTURES_MSG1}
                                                MESSAGE_2={isFilterApplied ? AppLabels.NO_CONTEST_FOR_FILTER_2 : AppLabels.NO_FIXTURES_MSG3}
                                                BUTTON_TEXT={AppLabels.GO_BACK_TO_LOBBY}
                                                onClick={this.goBack}
                                            />
                                        }
                                        {
                                            FixturedContest.length == 0 && FixturedPinContest.length == 0 && isListLoading &&
                                            ShimmerList.map((item, index) => {
                                                return (
                                                    <Shimmer key={index} index={index} />
                                                )
                                            })
                                        }
                                    </InfiniteScroll>
                                </Col>
                            </Row>
                        </div>
                        {
                            WSManager.loggedIn() && showMyTeamBtn &&
                            <div style={{ display: "flex" }} className="bottom">
                                {userTeamListSend.length > 0 && <button className="custom-footer-buttons" style={{ borderRight: "0.5px solid white" }} onClick={() => this.redirectToMyTeams()}>{AppLabels.MY_TEAMS}</button>}
                                <button className="custom-footer-buttons" onClick={() => this.createTeamAndJoin()}>{AppLabels.CREATE_YOUR_TEAM}</button>
                            </div>
                        }
                        {/* {
                            WSManager.loggedIn() && showMyTeamBtn &&
                            <>
                                {
                                    <>
                                        {
                                             ?
                                                <Button onClick={() => this.redirectToMyTeams()} className="btn-block btn-primary bottom">{AppLabels.MY_TEAMS}</Button>
                                                :
                                                TotalTeam.length < parseInt(Utilities.getMasterData().a_teams) &&
                                                <Button onClick={() => this.redirectToMyTeams()} className="btn-block btn-primary bottom">{AppLabels.CREATE_YOUR_TEAM}</Button>

                                        }
                                    </>
                                }

                            </>
                        } */}

                        {
                            showContestDetail &&
                            <ContestDetailModal
                                IsContestDetailShow={showContestDetail}
                                onJoinBtnClick={this.onSubmitBtnClick}
                                IsContestDetailHide={this.ContestDetailHide}
                                OpenContestDetailFor={FixtureData}
                                activeTabIndex={activeTab}
                                LobyyData={this.state.LobyyData} />
                        }

                        {
                            showConfirmationPopUp &&
                            <ConfirmationPopup
                                IsConfirmationPopupShow={this.ConfirmatioPopUpShow}
                                IsConfirmationPopupHide={this.ConfirmatioPopUpHide}
                                TeamListData={userTeamListSend}
                                TotalTeam={TotalTeam}
                                FixturedContest={FixtureData}
                                ConfirmationClickEvent={this.ConfirmEvent}
                                CreateTeamClickEvent={this.createTeamAndJoin}
                                lobbyDataToPopup={LobyyData}
                                fromContestListingScreen={true}
                                fromMyTeams={this.props.location.state.from == 'MyTeams' ? true : false}
                                createdLineUp={this.state.lineup_master_id}
                                showDownloadApp={this.showDownloadApp}
                                selectedLineUps={this.state.lineup_master_idArray}
                            />
                        }

                        {
                            showSharContestModal &&
                            <ShareContestModal
                                IsShareContestModalShow={this.shareContestModalShow}
                                IsShareContestModalHide={this.shareContestModalHide}
                                FixturedContestItem={FixtureData} />
                        }

                        {/*
                            showThankYouModal &&
                            <Thankyou ThankyouModalShow={this.ThankYouModalShow}
                                ThankYouModalHide={this.ThankYouModalHide}
                                goToLobbyClickEvent={this.goToLobby}
                                seeMyContestEvent={this.seeMyContest} />
                        */}

                        {
                            showCollectionInfo &&
                            <CollectionInfoModal
                                IsCollectionInfoShow={showCollectionInfo}
                                IsCollectionInfoHide={this.CollectionInfoHide} />
                        }
                        {
                            showDAM &&
                            <DownloadAppBuyCoinModal
                                hideM={this.hideDownloadApp}
                            />
                        }
                        {
                            allowRevFantasy && showAlert &&
                            <MyAlert
                                isMyAlertShow={showAlert}
                                hidemodal={() => this.hideAlert()}
                                isFrom={'contest-listing'}
                                message={(AppLabels.YOU_CAN_CREATE_ONLY_10TEAMS || '').replace('10', Utilities.getMasterData().a_teams)}
                            />
                        }
                    </div>
                )}
            </MyContext.Consumer>
        )
    }
}